import React, { useMemo } from 'react';

import { useInject } from '@vk-hr-tek/core/ioc';
import { ValidationService } from '@vk-hr-tek/core/validation';
import { RadioInputComplexLabel } from '@vk-hr-tek/app-ui/form';

import { SingleTextChoiceAnswerSettings } from '@app/gen/community';

import { ContentSurveysChoiceLabel } from '../ContentSurveysChoiceLabel';

interface ContentSurveysSingleChoiceProps {
  fieldIndex: number;
  answerSettings: SingleTextChoiceAnswerSettings;
}

export const ContentSurveysSingleChoice = ({
  fieldIndex,
  answerSettings,
}: ContentSurveysSingleChoiceProps) => {
  const validator = useInject(ValidationService);

  const name = `questions[${fieldIndex}]`;
  const { answer_options: answerOptions } = answerSettings;

  const options = useMemo(() => {
    return answerOptions.map((option) => ({
      label: {
        option,
      },
      value: option.id || '',
    }));
  }, [answerOptions]);

  return (
    <RadioInputComplexLabel
      name={`${name}.answer`}
      variant="secondary"
      options={options}
      allowClear
      render={ContentSurveysChoiceLabel}
      validateArray={[validator.required('Обязательное поле')]}
    />
  );
};
